module.exports = __webpack_public_path__ + "statics/img/step-en.22d0167f.gif";